import { useViewPort } from "@website/hooks/viewport";
import Close from "@website/icons/components/close";
import { usePosition, useShow } from "@website/ui-old/mini-popover/hooks";
import styles from "@website/ui-old/mini-popover/mini-popover.module.scss";
import { MiniPopoverPropertiesType } from "@website/ui-old/mini-popover/mini-popover.types";
import { TransitionV2 } from "@website/ui/transition";
import { FC, memo, useRef } from "react";

const MiniPopover: FC<MiniPopoverPropertiesType> = (properties) => {
  const { animate, children, title, fullWidth, gap, datatestid, className } =
    properties;
  const popoverReference = useRef<HTMLDivElement>(null);
  const {
    popoverProperties,
    transitionProps,
    closeButtonProps,
    popoverOpen,
    animateOpen,
    backdrop
  } = useShow(properties, popoverReference);
  const { horizontalPosition } = usePosition(properties, popoverReference);
  const { isMobile } = useViewPort();
  // const { sheetReference, sheetBottom } = useSheet(popoverOpen);
  // const { containerHeight } = useHeight();

  if (popoverOpen) {
    return (
      <TransitionV2 {...transitionProps} in={animateOpen}>
        {(state) => (
          <div
            className={`${styles["container"]} ${
              animate === "normal"
                ? ""
                : `${styles["animate-bottom"]} ${styles[state]}`
            } ${fullWidth ? styles["full"] : ""} ${
              styles[horizontalPosition]
            } `}
            data-testid={datatestid}
            onClick={
              isMobile && backdrop?.onClick ? backdrop?.onClick : undefined
            }
            style={{ marginTop: isMobile ? "0px" : gap || "0px" }}
            // ref={sheetReference}
            // style={isMobile ? { bottom: `${sheetBottom}px` } : {}}
            // style={{ height: isMobile ? `${containerHeight}px` : "auto" }}
          >
            {!isMobile && <div className={styles["backdrop"]} {...backdrop} />}
            <div
              ref={popoverReference}
              {...popoverProperties}
              className={`${styles["mini-popover"]}`}
            >
              {title ? (
                <div className={styles["header"]}>
                  <div className={styles["title"]}>{title}</div>
                  <div className={styles["close-button"]}>
                    <Close
                      className={styles["close-button-icon"]}
                      {...closeButtonProps}
                    />
                  </div>
                </div>
              ) : null}
              <div className={`${className} ${styles["main"]}`}>{children}</div>
            </div>
          </div>
        )}
      </TransitionV2>
    );
  }
  return null;
};

const MiniPopoverMemoized = memo(MiniPopover);
/**
 * @deprecated please use @website/ui instead
 */
export { MiniPopoverMemoized /**
 * @deprecated please use @website/ui instead
 */ as MiniPopover };
